// extracted by mini-css-extract-plugin
export var icon = "_h-1";
export var subtext = "_h-0";